var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"font-weight":"bold"}},[_vm._v("\n    "+_vm._s(_vm.boardName)+"\n  ")]),_vm._l((_vm.parameters),function(item,index){return _c('Voltage',{key:index,attrs:{"index":index,"parameter":item}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }